

export const routerApiUrl = 'http://127.0.0.1:6130/api'